import { render } from "./TermsPrivacy.vue?vue&type=template&id=5ae84931&scoped=true"
import script from "./TermsPrivacy.vue?vue&type=script&lang=js"
export * from "./TermsPrivacy.vue?vue&type=script&lang=js"

import "./TermsPrivacy.vue?vue&type=style&index=0&id=5ae84931&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ae84931"]])

export default __exports__